import { call, debounce, select, take, takeEvery } from 'redux-saga/effects'

import {
    ENABLE_QUERY_ON_FILTERS_CHANGE, QUERY_ON_MAP_MOVE,
    RESET_FILTERS, UPDATE_FILTERS, UPDATE_PRIMARY_FILTERS,
} from '../actions'
import { isMapRendered } from '../helpers'
import { UPDATE_PAGE_SIZE, triggerListQuery } from '../../../integrations/list'
import { UPDATE_LOCATION } from '../../../integrations/geolocation'
import { MAP_BOUNDS_UPDATE } from '@bikemap/js/integrations/map/actions'

const DEBOUNCE_TIME = 200

function* queryOnFiltersChange(action) {
    const queryEnabled = yield select(state => state.queryOnFiltersChange)
    if (queryEnabled) {
        yield call(triggerListQuery, 'results', action)
    }
}

function* queryOnMapMove(action) {
    const location = yield select(state => state.geolocation.location)
    if (!location) {
        // Map viewport bounds are relevant because we are not searching within a location
        yield call(triggerListQuery, 'results', action)
    }
}

/**
 * Triggers new search queries implicitly when certain changes to the state happen.
 */
export default function* implicitQuerySaga() {
    if (isMapRendered()) {
        // Wait with the first query until we have bounds if we're using map
        yield take(MAP_BOUNDS_UPDATE)
    }

    yield debounce(DEBOUNCE_TIME, UPDATE_FILTERS, queryOnFiltersChange)
    yield takeEvery(action => [
        RESET_FILTERS, UPDATE_PRIMARY_FILTERS, UPDATE_LOCATION, UPDATE_PAGE_SIZE,
        ENABLE_QUERY_ON_FILTERS_CHANGE,
    ].includes(action.type), triggerListQuery, 'results')
    yield debounce(DEBOUNCE_TIME, QUERY_ON_MAP_MOVE, queryOnMapMove)
}
